import { CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DataTable2 from "examples/Tables/DataTable2";
import TmpxLogsOverviewTable from "./tmpxLogsOverviewTable";

function TmpxLogs() {
  const { t } = useTranslation();
  const { tableData, loading, error } = TmpxLogsOverviewTable();

  if (loading) {
    return (
      <MDBox p={3}>
        <MDTypography variant="h6" fontWeight="medium" gutterBottom>
          <CircularProgress />
        </MDTypography>
      </MDBox>
    );
  }

  if (error) {
    return (
      <MDBox p={3}>
        <MDTypography variant="h6" color="error" gutterBottom>
          {t("scenarios.tmpxLogs.loadError")} {error}
        </MDTypography>
      </MDBox>
    );
  }

  return (
    <DashboardLayout>
      <div className="diagramContainer">
        <div className="scrollable-100">
          <DataTable2 table={tableData} canSearch />
        </div>
      </div>
    </DashboardLayout>
  );
}

export default TmpxLogs;
